import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../core/data/redux/store";
import {
  getEmployeeBySupervisorId,
  getEmployeeByUserId,
  getEmployeeById,
} from "../../core/data/redux/employee/employeeAction";
import AssignGoal from "../../core/modals/assigngoal";
import { fetchAllGoallistbyemployeeId } from "../../core/data/redux/performance/goallist/goallistAction";
import DeleteModal1 from "../../core/modals/deleteModal1";
import { deleteGoallist } from "../../core/data/redux/performance/goallist/goallistAction";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { message } from "antd";
import { filterByStatus } from "../../core/utils/filterActiveData";

const GoalAssign = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const { employeesbyUser, employeeFullDetails, employeeBySupervisor } = useSelector((state: any) => state.employee);
  const { goal ,loadingStates} = useSelector((state: any) => state.performance.goal);
  const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
  const [listofgoallist, setlistofgoallist] = useState<any>(null);
  const [isAssignGoalOpen, setIsAssignGoalOpen] = useState(false);
  const [statusMap, setStatusMap] = useState<{ [key: string]: string }>({});
  const [editingGoal, setEditingGoal] = useState<any>(null);
  const [selectedGoal, setSelectedGoal] = useState<any>(null);
  const activeSupervisor = filterByStatus(employeeBySupervisor, "active", "employee_status");
  useEffect(() => {
    if (user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId.toString() }));
    }
  }, [user?.UserId, dispatch]);

  useEffect(() => {
    if (employeesbyUser?.employeeId) {
      dispatch(getEmployeeById({ employeeId: employeesbyUser.employeeId }));
    }
  }, [employeesbyUser?.employeeId, dispatch]);

  useEffect(() => {
    const supervisorId = employeeFullDetails?.employee?.[0]?.SupervisorId;
    if (supervisorId) {
      dispatch(getEmployeeBySupervisorId({ userId: supervisorId.toString() }));
    }
  }, [employeeFullDetails?.employee, dispatch]);

  const handleEmployeeClick = (employee: any) => {
    setSelectedEmployee(employee);
    dispatch(fetchAllGoallistbyemployeeId(employee.EmployeeID)).then((res) => {
      setlistofgoallist(res.payload.data);
    });
  };

  const handleCloseAssignGoal = () => {
    setIsAssignGoalOpen(false);
    setEditingGoal(null);
  };

  const handleEditGoal = (goal: any) => {
    setEditingGoal(goal);
    setIsAssignGoalOpen(true);
  };

  const handleDeleteGoal = (goal: any) => {
    setSelectedGoal(goal); // Store the goal
    setIsDeleteModalVisible(true);
  };

  const handleStatusChange = (goalId: string, newStatus: string) => {
    setStatusMap((prev) => ({ ...prev, [goalId]: newStatus }));
  };

  const handleDeletePolicy = (id: any) => {
    const goallistId = id;
    dispatch(deleteGoallist(goallistId))
      .then((resp: any) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
        } else {
          setIsDeleteModalVisible(false);
          message.warning(resp.payload.message);
        }
      })
      .catch((error: any) => {
        console.error("error is ", error);
      });
  };

  return (
    <div className="d-flex">
      <div className="employee-list p-3 border-end" style={{ width: "250px" }}>
        <h5>Direct Reportees</h5>
        <ul className="list-group mt-2">
          {activeSupervisor.sort((a: any, b: any) => a.Name.localeCompare(b.Name))
          .map((emp: any) => (
            <li
              key={emp.EmployeeID}
              className={`list-group-item ${
                selectedEmployee?.EmployeeID === emp.EmployeeID ? "active" : ""
              }`}
              onClick={() => handleEmployeeClick(emp)}
              style={{
                cursor: "pointer",
                backgroundColor:
                  selectedEmployee?.EmployeeID === emp.EmployeeID
                    ? "#582EB7"
                    : "transparent",
                color:
                  selectedEmployee?.EmployeeID === emp.EmployeeID
                    ? "#fff"
                    : "#000",
              }}
            >
              {emp.Name}
            </li>
          ))}
        </ul>
      </div>

      <div className="content flex-grow-1 p-3">
        {selectedEmployee && (
          <div className="container-fluid">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
              <h2 className="m-0">Goals - {selectedEmployee.Name}</h2>
              <button
                className="btn btn-primary"
                onClick={() => setIsAssignGoalOpen(true)}
              >
                Assign Goal
              </button>
            </div>

            <div className="table-responsive">
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      S.No
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Goal
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Weightage
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Start Date
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      End Date
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Progress
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        backgroundColor: "#582EB7",
                        color: "white",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {listofgoallist && listofgoallist.length > 0 ? (
                    listofgoallist.map((goal: any, index: number) => (
                      <tr key={goal.id}>
                        <td>{index + 1}</td>
                        <td>{goal.goal_name}</td>
                        <td>{goal.weightage}</td>
                        <td>{new Date(goal.StartDate).toLocaleDateString()}</td>
                        <td>{new Date(goal.EndDate).toLocaleDateString()}</td>
                        <td>{goal.progress}%</td>
                        <td>{goal.Status}</td>
                        <td>
                          <EditOutlined
                            className="text-primary me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEditGoal(goal)}
                          />
                          <DeleteOutlined
                            className="text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDeleteGoal(goal)}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No Goals Assigned
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <AssignGoal
        isOpen={isAssignGoalOpen}
        onClose={handleCloseAssignGoal}
        employee={selectedEmployee}
        goaldata={editingGoal}
      />

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedGoal && handleDeletePolicy(selectedGoal.id)}
      />
    </div>
  );
};

export default GoalAssign;
